import { Part } from "shared";

type Assembly = Pick<Part, "id"> & { children?: Pick<Part, "id">[] | undefined | null };

export const computeAssemblyComplexity = (assembly: Assembly | null | undefined) => {
  const flattenAssembly = (part: Assembly | null | undefined): Assembly[] => {
    if (!part) {
      return [];
    }
    if (!part.children || part.children.length === 0) {
      return [part];
    }

    return [part, ...part.children.flatMap((child) => flattenAssembly(child))];
  };

  const flattenedParts = flattenAssembly(assembly);

  return flattenedParts.length;
};
